import { useNavigate } from "react-router-dom";
import { ForbiddenPage } from "@trillion/ui";

import { useAuth } from "./hooks";

// Auth-aware wrapper around @trillion/ui's ForbiddenPage: gives the shared 403 page a working logout
// escape hatch. Mirrors AdminShell.handleLogout — clears the (stale) session, then lands the user on
// /login so they can sign in again and mint a session carrying their current roles. Registered as a
// sibling `/forbidden` route in each admin app (see AdminShell docs). @trillion/ui stays router/auth-
// agnostic; this package owns react-router + useAuth.

export function AdminForbiddenPage() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    navigate("/login");
  }

  return <ForbiddenPage onLogout={handleLogout} />;
}
